import { FullLoader } from 'components/atoms/FullLoader/FullLoader'
import { LoggedLayout } from 'components/templates/homeTemplate/Logged'
import { CampaignsUI } from 'features/campaigns'
import { ui as ContactsUI } from 'features/contacts'
import { MailboxUI } from 'features/messaging'
import { TeamUI } from 'features/team'
import { ui as WebhooksUI } from 'features/webhooks'
import { AccountRoute } from 'pages/account'
import { ErrorBoundary, ErrorRoute } from 'pages/error'
import { MailboxPage } from 'pages/Mailbox'
import { NotFoundPage } from 'pages/notfound'
import { OpsSaveTokensRoute } from 'pages/ops-save-tokens'
// Styles
import '@fontsource-variable/open-sans'
import 'semantic-ui-css/semantic.min.css' // TODO: Bad reset, delete in future
import 'reset-css'

import './style.scss'
import '../../assets/main.scss'

import { UpgradePage } from 'pages/upgrade/UpgradePage'
import {
	createBrowserRouter,
	Navigate,
	type RouteObject,
	RouterProvider
} from 'react-router-dom'

import { AuthCallback } from './AuthCallback'
import { useListeners } from './hooks/useListeners'
import { useTrackingUser } from './hooks/useTrackingUser'
import { InvitationCallback } from './InvitationCallback'
import { AuthWrapper } from './LayoutUser'

const REDIRECTS: RouteObject[] = [
	{ element: <Navigate replace to='/campaigns' />, index: true },
	{ element: <Navigate replace to='/messaging' />, path: '/mailbox' },
	{ Component: MailboxPage, path: '/mailbox/thread/:conversation' }
]

const router = createBrowserRouter([
	{
		children: [
			...REDIRECTS,
			{ Component: AuthCallback, path: '/auth_callback' },
			{ Component: InvitationCallback, path: '/invitation_callback' },
			OpsSaveTokensRoute,
			{ Component: FullLoader, path: '/referrer/:id' },
			ErrorRoute,
			{
				children: [
					{
						children: [
							CampaignsUI.Routes,
							...ContactsUI.Route,
							TeamUI.Route,
							MailboxUI.Route,
							{ Component: UpgradePage, path: '/upgrade' },
							AccountRoute,
							WebhooksUI.Route
						],
						Component: LoggedLayout
					},
					{ Component: NotFoundPage, path: '*' }
				],
				Component: AuthWrapper
			}
		],
		ErrorBoundary,
		HydrateFallback: FullLoader
	}
])

export function App() {
	useListeners()
	useTrackingUser()

	return <RouterProvider router={router} />
}
